import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "semantic-ui-react";

import "components/UploadImage/UploadImage.scss";
import { createFormHelper } from "lib/Form";
import { UploadFilePreview } from "lib/Form/components/FormUploadImage/UploadFilePreview";
import { clickOnId, getNameFromURL } from "utils/common";

import type { BrandSettingsFormValues } from "modules/BrandsDashboard/components/BrandSettingsFields";

const LOGO_INPUT_ID = "brand-logo-upload";

const FormHelper = createFormHelper<BrandSettingsFormValues>();

export const BrandLogoUpload = () => {
  const { t } = useTranslation();

  const { watch, setValue } = FormHelper.useFormContext();
  const [logo, logoFile] = watch(["logo", "logoFile"]);
  const [filePreview, setFilePreview] = useState("");

  useEffect(() => {
    if (!logoFile) {
      setFilePreview("");
      return;
    }

    const objectUrl = URL.createObjectURL(logoFile);
    setFilePreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [logoFile]);

  const handleSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => setValue("logoFile", event.target.files?.[0] ?? null);

  const handleDelete = () => {
    setValue("logo", "");
    setValue("logoFile", null);
  };

  return (
    <div className="upload-container">
      <div className="UploadImage new">
        <div className="button" onClick={() => clickOnId(LOGO_INPUT_ID)}>
          <p className="btn-text">{t("v8_choose_file", "Choose File")}</p>
        </div>
        <p className="fileInput-ellipsis">{logoFile?.name || getNameFromURL(logo) || t("v8_choose_file", "Choose File")}</p>
      </div>
      <Input id={LOGO_INPUT_ID} className="hidden-file-input" accept="image/png, image/jpeg, image/gif" type="file" onChange={handleSelectFile} />
      <UploadFilePreview image={filePreview || logo} onDelete={handleDelete} />
    </div>
  );
};
